import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GetTeamQueryKey = 'GET_TEAM_BY_ID';

export const useGetTeamByTeamId = (teamId: number) => {
  const { fetchTeamByTeamId } = useServicesContext();

  return useQuery({
    queryKey: [GetTeamQueryKey, teamId],
    queryFn: () => fetchTeamByTeamId(teamId),
  });
};
